<lucide-icon *ngIf="iconObject" [img]="iconObject" [size]="size" [color]="resolvedColor" [style.width.px]="size"
  [style.height.px]="size" [style.stroke]="resolvedColor"></lucide-icon>